var _rect, _rect2, _path, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect5, _rect6, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralsInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.4059,
    y: 17.7946,
    width: 72.1899,
    height: 72.1899,
    rx: 36.0949,
    fill: "#212327"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4059,
    y: 17.7946,
    width: 72.1899,
    height: 72.1899,
    rx: 36.0949,
    stroke: "#0B0B0B",
    strokeWidth: 1.07746
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2853 32.6456C34.0058 32.7022 33.3942 32.9251 32.9264 33.1407C32.4584 33.3565 32.005 33.5469 31.9188 33.5638C31.7381 33.5994 31.0625 34.1526 30.5548 34.6803C30.3634 34.8793 29.9647 35.527 29.6688 36.1197C29.1458 37.1676 29.1309 37.2418 29.1309 38.8012C29.1309 40.5137 29.2339 40.8925 30.109 42.3976C30.3322 42.7815 30.471 43.166 30.4174 43.2523C30.364 43.3385 30.3807 43.3718 30.4548 43.3262C30.5747 43.2524 32.7583 46.9153 32.6568 47.0198C32.6341 47.0429 32.7462 47.2044 32.9059 47.3787C33.0657 47.5528 33.425 48.1374 33.7045 48.6779C33.984 49.2183 34.2712 49.7027 34.3428 49.7544C34.4142 49.8061 34.4314 49.956 34.3807 50.0876C34.3294 50.2209 34.3489 50.2896 34.4248 50.2429C34.5838 50.1451 34.9001 50.6638 34.7642 50.7994C34.7138 50.8496 34.7422 50.8907 34.8276 50.8907C35.0119 50.8907 35.5921 51.8305 35.5921 52.1292C35.5921 52.2442 35.6426 52.3381 35.7043 52.3381C35.766 52.3381 35.9443 52.5824 36.1007 52.8809C36.2569 53.1794 36.6311 53.8318 36.9322 54.3308C37.2332 54.8297 37.4796 55.2707 37.4796 55.3108C37.4796 55.3509 37.6389 55.6266 37.8337 55.9234C38.0284 56.2202 38.2082 56.5608 38.233 56.6802C38.2579 56.7996 38.3178 56.9299 38.3662 56.9697C38.488 57.07 39.5375 58.8137 39.8469 59.4302C39.9867 59.7088 40.1628 60.0344 40.2382 60.1539C40.6033 60.7324 41.5451 62.3357 41.5451 62.379C41.5451 62.4061 41.8809 63.0073 42.2914 63.7154C42.7019 64.4233 43.1826 65.263 43.3599 65.5815C43.5372 65.8999 43.9907 66.6951 44.3681 67.3487C44.7455 68.0022 45.0112 68.6063 44.9586 68.6911C44.9061 68.7758 44.937 68.8273 45.0273 68.8055C45.1176 68.7836 45.357 69.0587 45.5592 69.417C45.7613 69.7752 46.0188 70.2126 46.1317 70.3889C46.2443 70.5652 46.3365 70.8093 46.3365 70.9316C46.3365 71.0538 46.3881 71.1538 46.4512 71.1538C46.5142 71.1538 46.8245 71.6155 47.1409 72.18C47.4571 72.7443 47.872 73.4826 48.0629 73.8207C48.2537 74.1587 48.5921 74.5573 48.8149 74.7065C49.0376 74.8557 49.1963 75.0158 49.1675 75.0621C49.1 75.1711 49.8562 75.2672 50.7111 75.2582C51.529 75.2495 52.1427 74.8548 52.6004 74.043C52.7783 73.7276 52.977 73.4696 53.0422 73.4696C53.1074 73.4696 53.1501 73.4208 53.1373 73.361C53.1112 73.2402 53.3711 72.6466 53.5966 72.3117C53.677 72.1923 54.1894 71.3297 54.7354 70.3949C55.2811 69.4601 55.7814 68.7437 55.8468 68.8028C55.9125 68.8619 55.9152 68.8228 55.8531 68.7157C55.7847 68.598 55.8616 68.3572 56.0475 68.1064C56.2167 67.8784 56.355 67.6633 56.355 67.6285C56.355 67.5936 56.6223 67.1262 56.9492 66.5901C57.6608 65.4225 58.0062 64.8252 58.569 63.789C59.3206 62.4051 59.7824 61.7373 59.9084 61.8515C59.9761 61.9128 59.9842 61.8811 59.9264 61.7811C59.8683 61.6807 59.9554 61.4115 60.121 61.1799C60.2858 60.9492 60.4205 60.7287 60.4205 60.6901C60.4205 60.6515 61.0085 59.6321 61.7273 58.425C62.446 57.2179 63.034 56.1808 63.034 56.1206C63.034 56.0604 63.1521 55.8849 63.2962 55.7306C63.4404 55.5761 63.5744 55.3848 63.5939 55.3052C63.6983 54.8778 65.9039 51.3375 66.0073 51.4312C66.0746 51.4921 66.0892 51.4713 66.0399 51.3847C65.9905 51.2982 66.2087 50.7862 66.5248 50.2469C66.8409 49.7077 67.0995 49.2435 67.0995 49.2153C67.0995 49.1872 67.4588 48.5734 67.8981 47.8513C68.3373 47.1292 68.6966 46.5133 68.6966 46.4827C68.6966 46.452 69.0233 45.9018 69.4226 45.2601C69.8219 44.6183 70.1486 44.0656 70.1486 44.032C70.1486 43.9983 70.4753 43.4173 70.8746 42.7411C71.2739 42.0647 71.6005 41.4036 71.6005 41.2716C71.6005 41.1396 71.6519 41.0633 71.7148 41.1019C71.7777 41.1407 71.844 40.4444 71.8625 39.5546C71.8915 38.1464 71.8493 37.8072 71.5359 36.9357C71.338 36.385 71.1179 35.8965 71.0471 35.8502C70.9761 35.8037 70.8355 35.6099 70.7347 35.4193C70.3453 34.6827 69.3438 33.7807 68.4558 33.3668C66.5306 32.4697 67.3491 32.5076 50.3352 32.5259C41.7873 32.535 34.5648 32.5888 34.2853 32.6456ZM48.0789 50.4539C48.0789 57.779 48.0524 63.7723 48.0201 63.7723C47.9518 63.7723 46.5645 61.4374 46.5368 61.2756C46.5264 61.2158 46.5021 61.1182 46.4827 61.0585C46.4633 60.9987 46.4568 60.8962 46.4681 60.8306C46.4795 60.7649 46.4318 60.7464 46.3619 60.7895C46.2922 60.8325 46.1443 60.6908 46.0332 60.4746C45.9221 60.2584 45.6419 59.7558 45.4105 59.3578C43.8701 56.7093 42.4162 54.1758 42.4162 54.1401C42.4162 54.1169 42.0872 53.5691 41.6852 52.9228C41.2778 52.268 40.9988 51.6703 41.055 51.5726C41.1107 51.4762 41.1024 51.4458 41.0369 51.505C40.9713 51.5642 40.8464 51.4872 40.7594 51.3338C40.2534 50.4412 39.2469 48.6932 38.3794 47.2C38.0557 46.6427 37.7699 46.0894 37.7442 45.9703C37.7185 45.8512 37.6184 45.6883 37.5219 45.6084C37.4254 45.5285 36.9761 44.8118 36.5233 44.0158C36.0706 43.2197 35.581 42.373 35.4352 42.1342C34.604 40.7721 33.7045 39.0188 33.7045 38.7605C33.7045 38.2188 33.9646 37.7674 34.4549 37.4576C34.9282 37.1586 35.0802 37.1518 41.5088 37.1438L48.0789 37.1356V50.4539ZM66.5299 37.8533C66.8869 38.2092 66.9543 38.3925 66.9543 39.0077C66.9543 39.6971 66.5376 40.7297 66.3391 40.532C66.2941 40.4871 66.2672 40.5378 66.2791 40.6444C66.3089 40.9093 63.4273 45.816 63.2913 45.7322C63.2315 45.6953 63.2158 45.7517 63.2566 45.8575C63.2973 45.9633 63.1658 46.2723 62.9645 46.5445C62.7632 46.8166 62.5984 47.0842 62.5984 47.1395C62.5984 47.3558 61.0447 49.8741 60.9534 49.8056C60.8998 49.7656 60.8861 49.7737 60.923 49.8237C60.9597 49.8737 60.8369 50.183 60.65 50.5112C60.1998 51.3013 58.9963 53.3666 58.8261 53.6407C58.752 53.7601 58.188 54.7371 57.5726 55.8118C55.3492 59.695 54.7194 60.7328 54.5861 60.7328C54.5115 60.7328 54.4804 60.7816 54.5173 60.8413C54.5542 60.9011 54.4277 61.2104 54.2365 61.5288C54.0451 61.8473 53.843 62.2055 53.7871 62.3249C53.7312 62.4443 53.4695 62.9002 53.2057 63.338L52.7259 64.1341L52.7256 50.7822L52.7251 37.4303H59.4153H66.1055L66.5299 37.8533Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4059,
    y: 11.3297,
    width: 72.1899,
    height: 72.1899,
    rx: 36.0949,
    fill: "#373C44"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4059,
    y: 11.3297,
    width: 72.1899,
    height: 72.1899,
    rx: 36.0949,
    stroke: "#0B0B0B",
    strokeWidth: 1.07746
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1746 26.7392C42.2525 26.8955 59.8221 26.0723 60.0572 26.7392C60.2537 27.406 60.0185 30.5436 59.4292 30.9351C57.9392 31.9547 56.5669 32.9743 55.586 33.915C56.802 36.2281 58.606 38.7778 60.5663 41.3662C64.4095 46.5817 75.3898 55.0137 68.0175 64.3076C65.7431 67.1312 62.6457 68.6599 58.9975 68.6599H41.1941C37.5861 68.6599 34.4485 67.1298 32.2143 64.3076C24.8032 55.0137 35.8223 46.5817 39.6655 41.3662C41.5871 38.7778 43.391 36.2295 44.6071 33.915C43.6262 32.9743 42.2538 31.9547 40.7639 30.9351C40.0182 30.4246 39.783 26.7392 40.1746 26.7392Z",
    fill: "#AE7A00",
    stroke: "#171819",
    strokeWidth: 0.705827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6071 31.4844H47.3518H50.0965H52.8413H55.586C56.802 33.7975 58.606 36.3471 60.5663 38.9355C64.4095 44.1511 75.3898 52.5831 68.0175 61.877C65.7431 64.7393 62.6457 66.2293 58.9975 66.2293C53.0765 66.2293 47.154 66.2293 41.1941 66.2293C37.5861 66.2293 34.4485 64.7393 32.2143 61.877C24.8032 52.5831 35.8223 44.1511 39.6655 38.9355C41.5871 36.3471 43.391 33.7975 44.6071 31.4844Z",
    fill: "#FFC949",
    stroke: "#171819",
    strokeWidth: 0.705827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6072 31.4862H55.5875C56.5683 30.5455 57.9407 29.5259 59.4307 28.5063C60.0186 28.1148 60.2538 27.4078 60.0588 26.741C59.8236 26.0742 59.2356 25.6426 58.5287 25.6426H41.666C40.9605 25.6426 40.3725 26.0742 40.1761 26.741C39.9409 27.4078 40.176 28.1134 40.764 28.5063C42.254 29.5245 43.6263 30.5441 44.6072 31.4862Z",
    fill: "#FFC949",
    stroke: "#171819",
    strokeWidth: 0.705827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1953 33.916H50.9204",
    stroke: "#171819",
    strokeWidth: 0.705827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.623 33.916H57.0346",
    stroke: "#171819",
    strokeWidth: 0.705827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8594 66.2305V68.6612",
    stroke: "#171819",
    strokeWidth: 0.705827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9238 66.2305V68.6612",
    stroke: "#171819",
    strokeWidth: 0.705827,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9436 40.6445V40.4165H51.7156H48.9779H48.7498V40.6445V43.2847H46.2422H46.0142V43.5127V52.113V52.341H46.2422H51.4876V54.7489H46.2422H46.0142V54.9769V57.8472V58.0752H46.2422H48.7498V60.7111V60.9391H48.9779H51.7156H51.9436V60.7111V58.0752H54.4512H54.6793V57.8472V49.2425V49.0145H54.4512H49.2058V46.6066H54.4512H54.6793V46.3786V43.5126V43.2845H54.4512H51.9436V40.6445Z",
    fill: "#595E65",
    stroke: "#0B0B0B",
    strokeWidth: 0.456058
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8785 58.6719C61.1385 58.6719 58.1016 61.7088 58.1016 65.4488C58.1016 69.1888 61.1385 72.2257 64.8785 72.2257C68.6185 72.2257 71.6554 69.1888 71.6554 65.4488C71.6554 61.7088 68.6185 58.6719 64.8785 58.6719Z",
    fill: "#144028",
    stroke: "#171819",
    strokeWidth: 0.451737,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8785 57.0645C61.1385 57.0645 58.1016 60.1014 58.1016 63.8414C58.1016 67.5814 61.1385 70.6183 64.8785 70.6183C68.6185 70.6183 71.6554 67.5814 71.6554 63.8414C71.6554 60.1014 68.6185 57.0645 64.8785 57.0645Z",
    fill: "#298552",
    stroke: "#171819",
    strokeWidth: 0.451737,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5805 59.5488H64.1754C63.7486 59.5488 63.3971 59.9003 63.3971 60.3271V62.36H61.3642C60.9374 62.36 60.5859 62.7115 60.5859 63.1383V64.5434C60.5859 64.9702 60.9374 65.3217 61.3642 65.3217H63.3971V67.3546C63.3971 67.7814 63.7486 68.1329 64.1754 68.1329H65.5805C66.0073 68.1329 66.3588 67.7814 66.3588 67.3546V65.3217H68.3917C68.8185 65.3217 69.17 64.9702 69.17 64.5434V63.1383C69.17 62.7115 68.8185 62.36 68.3917 62.36H66.3588V60.3271C66.3588 59.9003 66.0073 59.5488 65.5805 59.5488Z",
    fill: "#144028",
    stroke: "#171819",
    strokeWidth: 0.451737,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1684 70.041L62.0684 71.3709",
    stroke: "#171819",
    strokeWidth: 0.451737,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4059,
    y: 11.3297,
    width: 72.1899,
    height: 72.1899,
    rx: 36.0949,
    fill: "#373C44"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4059,
    y: 11.3297,
    width: 72.1899,
    height: 72.1899,
    rx: 36.0949,
    stroke: "#0B0B0B",
    strokeWidth: 1.07746
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6566 34.608C68.2239 35.0263 68.7196 34.6863 69.7128 35.8353C71.2533 37.585 71.2533 40.2229 70.8102 41.7902C69.9745 44.9247 66.1351 48.0583 63.0789 47.2484C60.0227 46.4127 58.7696 42.3384 59.3703 39.2038C59.3961 39.0472 59.4228 38.8906 59.4744 38.7597C60.3101 35.6261 63.5221 33.7456 66.6566 34.608ZM59.8135 48.5807C60.9892 50.5921 63.5746 51.2969 65.5859 50.148L66.9183 49.3648L67.6498 49.5472C69.6087 50.0697 70.2094 49.7564 71.1234 50.9312C72.2991 52.4717 72.1158 54.4831 71.75 55.8937L70.1569 61.7961L65.7693 60.6204L54.5128 57.6167L50.0469 56.4152L51.6141 50.5128C52.5282 47.1434 54.9569 46.151 58.3264 47.0651L59.058 47.2475L59.8135 48.5807Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1684 50.6696L27.2172 45.0805C26.8514 44.3489 26.9039 42.8867 27.7138 41.7377L40.5376 36.5144C41.2949 36.2011 42.1564 36.4361 42.5489 37.1677L45.4476 42.8876L45.7351 43.4358L46.4667 43.5141L41.5824 51.6886L30.1684 50.6696Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1446 43.593L49.8866 49.0255L53.0211 53.3348C53.2036 53.7006 52.7079 55.3194 52.3163 55.5028L44.3767 59.5513L36.4372 63.5999C36.2548 63.6782 36.0189 63.704 35.8365 63.6257C35.654 63.5731 35.4707 63.4432 35.3666 63.2341L29.959 52.7865L30.1681 50.6711L41.5813 51.6901L46.4655 43.5156L47.1446 43.593Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4587 41.8691L50.2007 47.3016L52.9695 52.7083C53.0736 52.9174 53.0736 53.1266 53.022 53.3348C52.9695 53.5172 52.8128 53.6748 52.6304 53.7789L44.6909 57.8274L36.7513 61.8493C36.5689 61.9534 36.3597 61.9534 36.1506 61.9018C35.9682 61.8493 35.7848 61.7193 35.7065 61.5102L30.1699 50.6711L40.6432 51.6109C41.2182 51.6634 41.7664 51.4017 42.0539 50.8793L47.4587 41.8691Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4605 41.8694L35.8907 40.5371L31.5547 50.8013L40.6441 51.6112C41.219 51.6637 41.7673 51.402 42.0547 50.8796L47.4605 41.8694Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0661 51.5586L36.1484 61.902",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.418 50.2773L53.0221 53.3336",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5524 50.7996L40.6418 51.6095C41.2168 51.662 41.765 51.4003 42.0524 50.8779L46.7533 43.0683L42.8614 35.4153C42.4698 34.6837 41.5816 34.3963 40.85 34.7621L28.3138 41.1362C27.5822 41.5278 27.2947 42.416 27.6605 43.1475L31.5524 50.7996Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6754 38.6814C40.5369 38.9688 41.1902 39.5696 41.5818 40.327C41.9733 41.0843 42.0517 41.9725 41.7909 42.834L41.3726 44.1138C41.2943 44.2963 41.0851 44.4013 40.9027 44.3488L39.9887 44.0355C39.8063 43.983 39.6754 43.7748 39.7537 43.5914L40.172 42.3116C40.3029 41.8933 40.2504 41.4501 40.0679 41.0843C39.8855 40.7185 39.5713 40.4311 39.1539 40.3012C38.7356 40.1703 38.2924 40.197 37.9266 40.4053C37.5609 40.5877 37.2734 40.9019 37.1435 41.3193L36.7252 42.5991C36.6726 42.7815 36.4644 42.8865 36.2553 42.834L35.3413 42.5466C35.1588 42.4682 35.0538 42.2591 35.1063 42.0767L35.5246 40.7969C35.8121 39.9354 36.4128 39.2563 37.1702 38.8905C37.9257 38.498 38.813 38.3939 39.6754 38.6814ZM39.3622 41.6058C39.258 41.3967 39.0747 41.24 38.8655 41.1617C38.6306 41.1092 38.3956 41.1359 38.2123 41.2142C38.0298 41.3184 37.8723 41.5017 37.794 41.7109L36.4617 45.7852C36.3833 46.0202 36.4091 46.2551 36.5142 46.4385C36.6183 46.6476 36.7749 46.8043 37.0108 46.8568C37.2199 46.9351 37.4549 46.9093 37.6641 46.8043C37.8465 46.7259 38.004 46.5435 38.0824 46.3076L39.4147 42.2333C39.4663 42.0241 39.4405 41.7892 39.3622 41.6058ZM40.7719 45.9676L40.3536 47.2474C40.0661 48.1089 39.4654 48.7622 38.708 49.1538C37.9506 49.5454 37.0624 49.6237 36.2009 49.3629C35.3394 49.0755 34.6604 48.4747 34.2946 47.7173C33.903 46.96 33.7979 46.0718 34.0854 45.2103L34.5037 43.9305C34.5562 43.7213 34.7645 43.6172 34.9736 43.6955L35.8876 43.983C36.0701 44.0613 36.1751 44.2705 36.1226 44.4529L35.7043 45.7327C35.5734 46.151 35.6002 46.5684 35.8084 46.9342C35.9908 47.3 36.305 47.6132 36.7224 47.7441C37.1407 47.8749 37.5581 47.8224 37.9239 47.6399C38.2897 47.4575 38.6029 47.1433 38.7338 46.7259L39.1521 45.4461C39.2046 45.237 39.4128 45.1329 39.622 45.2112L40.536 45.4987C40.7203 45.5503 40.8244 45.7594 40.7719 45.9676Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1486 61.9004L36.0703 63.6759",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.273 54.4824L51.168 56.2588",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0264 43.8535L27.8965 46.3348",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8005 45.551L58.5321 45.7334L59.2894 47.0915C60.4651 49.1029 63.0505 49.7819 65.0619 48.6321L66.3942 47.8489L67.1258 48.058C70.4953 48.9463 72.1141 51.0092 71.2259 54.3787L69.6328 60.3078L49.4961 54.9011L51.0892 48.9988C52.0022 45.6293 54.4319 44.637 57.8005 45.551Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.133 33.0929C62.9985 32.2572 59.7866 34.1119 58.9509 37.2456C58.0894 40.3801 59.5516 45.1335 62.6862 45.9692C65.8207 46.8049 69.4509 43.4096 70.2866 40.2751C71.1214 37.1414 69.2667 33.9295 66.133 33.0929Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8477 37.6887C62.2429 38.4986 64.5676 38.8644 67.5971 37.1405C67.5971 37.1405 68.0154 39.0211 70.2875 40.2751C71.1232 37.1405 69.2685 33.9286 66.1348 33.0929C63.0003 32.2572 59.7884 34.1119 58.9527 37.2456C58.9002 37.4022 58.8744 37.5321 58.8477 37.6887Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9863 56.1019L55.4744 50.5645",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2461 59.1332L66.735 53.5957",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6328 60.3086L70.1552 61.7975",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2461 59.1309L65.7685 60.6198",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2852 40.2754C70.2852 40.2754 70.7293 41.8159 70.3635 42.9658",
    stroke: "black",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2859 40.2761C70.2859 40.2761 70.73 41.8166 70.3642 42.9665C70.5733 42.5749 70.7042 42.1833 70.8083 41.7908C71.2524 40.2235 71.2524 37.5856 69.7109 35.8359C70.4683 37.1415 70.7033 38.7088 70.2859 40.2761Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2456 55.6055C47.3537 55.6055 44.1934 58.7658 44.1934 62.6577C44.1934 66.5496 47.3537 69.71 51.2456 69.71C55.1375 69.71 58.2978 66.5496 58.2978 62.6577C58.2978 58.7658 55.1375 55.6055 51.2456 55.6055Z",
    fill: "#144028",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2456 53.9355C47.3537 53.9355 44.1934 57.0959 44.1934 60.9878C44.1934 64.8797 47.3537 68.04 51.2456 68.04C55.1375 68.04 58.2978 64.8797 58.2978 60.9878C58.2978 57.0959 55.1375 53.9355 51.2456 53.9355Z",
    fill: "#298552",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9788 56.5195H50.5165C50.0724 56.5195 49.7066 56.8853 49.7066 57.3294V59.4449H47.5911C47.147 59.4449 46.7812 59.8107 46.7812 60.2548V61.717C46.7812 62.1611 47.147 62.5269 47.5911 62.5269H49.7066V64.6424C49.7066 65.0865 50.0724 65.4523 50.5165 65.4523H51.9788C52.4229 65.4523 52.7886 65.0865 52.7886 64.6424V62.5269H54.9041C55.3482 62.5269 55.714 62.1611 55.714 61.717V60.2548C55.714 59.8107 55.3482 59.4449 54.9041 59.4449H52.7886V57.3294C52.7886 56.8853 52.4229 56.5195 51.9788 56.5195Z",
    fill: "#144028",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4244 67.4375L48.3203 68.8214",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7294 30.7426C43.0694 30.4035 43.2519 30.2727 43.6435 29.9594C45.2623 28.7054 47.457 27.7131 49.7292 27.374C52.0796 27.0082 54.5084 27.2957 56.5455 28.6538C57.2246 29.0979 57.8511 29.6729 58.4003 30.3777L59.7059 28.8372C59.81 28.7331 60.3066 30.117 60.15 30.5353L58.661 34.3221C58.5827 34.5046 58.3736 34.5829 58.1911 34.4788L54.9525 32.3108C54.5867 32.0758 54.2476 30.7177 54.3775 30.7435L56.0231 31.1876C55.7624 30.9527 55.5007 30.7435 55.2399 30.5611C53.6994 29.542 51.8189 29.3071 49.9899 29.5945C48.1094 29.9078 46.2814 30.7177 44.9749 31.71C44.6616 31.9708 44.3741 32.2067 44.1134 32.4674C43.7476 32.8332 43.1994 32.8857 42.7552 32.624L42.3369 32.3891C42.0495 32.2325 42.0237 30.8485 41.997 30.5344C41.9721 30.1944 42.4945 30.9775 42.7294 30.7426Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2886 29.6974C42.6018 29.3574 42.9676 29.0442 43.3592 28.7309C44.9265 27.4769 47.0678 26.4846 49.3399 26.1455C51.6378 25.7797 54.0933 26.0672 56.183 27.4253C56.9661 27.9219 57.6977 28.5743 58.351 29.41L56.5745 30.7939C56.1046 30.1931 55.5555 29.6965 54.9557 29.3316C53.3884 28.3126 51.5079 28.0776 49.6799 28.3651C47.7993 28.6784 46.0229 29.4883 44.744 30.4806C44.4566 30.7413 44.1691 30.9772 43.9341 31.238C43.5941 31.6038 43.0201 31.6821 42.576 31.3946L42.4719 31.3421C42.2112 31.1597 42.0278 30.898 42.002 30.5589C41.9486 30.2466 42.0527 29.9591 42.2886 29.6974Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7463 31.0815L58.1158 33.2495C58.2982 33.3536 58.4815 33.2753 58.5599 33.0929L59.8654 29.306C59.918 29.1752 59.8912 28.9928 59.7871 28.8361C59.683 28.7053 59.5522 28.6537 59.3955 28.7053L54.7463 30.2984C54.6154 30.3509 54.5371 30.4808 54.5371 30.6641C54.5371 30.8199 54.6154 30.9765 54.7463 31.0815Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.470088,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralsInvite);
export default __webpack_public_path__ + "static/media/referrals-invite.26429e7e5924da196b4fbb2b4d0bcbb6.svg";
export { ForwardRef as ReactComponent };